export default __webpack_public_path__ + "static/media/logo-sipat-nexawt.38ff06a1.png";